import currencyContext from "../contexts/currency-context";
import { useContext } from "react";

export function useMoney() {
  const { m } = useContext(currencyContext);
  return m;
}
